//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { Amount } from './models/Amount';
import type { ContractAssets } from './models/ContractAssets';
import type { ContractBilling } from './models/ContractBilling';
import type { ContractInformation } from './models/ContractInformation';
import type { ContractPaginationResult } from './models/ContractPaginationResult';
import type { ContractsIds } from './models/ContractsIds';
import type { ContractsStatuses } from './models/ContractsStatuses';
import type { FileResponse } from './models/FileResponse';
import type { FinancialTypeCountResponse } from './models/FinancialTypeCountResponse';
import type { SearchContractRequest } from './models/SearchContractRequest';
import { Utilities } from './Utilities';

export class ContractsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContractsStatuses: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/statuses';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAmountToBeRegularized: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/amount-to-be-regularized';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractIds: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/ids';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        search: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/do-get-search';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractInformation: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/_information';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractAssets: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/assets';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractBilling: (
			siren: string,
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/id/{id}/_billing';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getExport: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/export';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getFinancialTypeCount: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/contracts/{siren}/financial-type-count';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get contracts Information
     * @return OK
     */
    async getContractsStatuses(
        siren: string,
    ): Promise<ContractsStatuses> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractsStatuses(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractsStatuses>(_response, false, []);
    }

    /**
     * Get amount to be regularized
     * @return OK
     */
    async getAmountToBeRegularized(
        siren: string,
    ): Promise<Amount> {
        const clientRequestUrl = this.baseUrl + this.routes.getAmountToBeRegularized(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<Amount>(_response, false, []);
    }

    /**
     * Get all contracts ids
     * @return OK
     */
    async getContractIds(
        siren: string,
    ): Promise<ContractsIds> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractIds(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractsIds>(_response, false, []);
    }

    /**
     * Get user contracts
     * @param body (optional) 
     * @return OK
     */
    async search(
        siren: string,
        body?: SearchContractRequest,
    ): Promise<ContractPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractPaginationResult>(_response, false, ['rentalEndDate', 'rentalStartDate', 'nextDueDate']);
    }

    /**
     * Get contract information
     * @return OK
     */
    async getContractInformation(
        siren: string,
        id: string,
    ): Promise<ContractInformation> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractInformation(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractInformation>(_response, false, ['rentalStartDate', 'nextDueDate', 'rentalEndDate']);
    }

    /**
     * Get contract assets
     * @return OK
     */
    async getContractAssets(
        siren: string,
        id: string,
    ): Promise<ContractAssets> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractAssets(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractAssets>(_response, false, []);
    }

    /**
     * Get contract billing
     * @return OK
     */
    async getContractBilling(
        siren: string,
        id: string,
    ): Promise<ContractBilling> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractBilling(
            siren,
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractBilling>(_response, false, []);
    }

    /**
     * Download contracts details
     * @return OK
     */
    async getExport(
        siren: string,
    ): Promise<FileResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getExport(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FileResponse>(_response, true, []);
    }

    /**
     * Get contract types count by financial type
     * @return OK
     */
    async getFinancialTypeCount(
        siren: string,
    ): Promise<FinancialTypeCountResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getFinancialTypeCount(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<FinancialTypeCountResponse>(_response, false, []);
    }
}
